module.exports = __webpack_public_path__ + "img/banner_2.c9f178be.png";